export default "__VITE_ASSET__CqcUjd3p__"